import { createClient } from "@supabase/supabase-js";

// Create a single supabase client for interacting with your database
export default createClient(
  process.env.VUE_APP_SUPABASE_URL,
  process.env.VUE_APP_SUPABASE_ANON_API_KEY
);
